export default __webpack_public_path__ + "static/media/jovelogo.78b760c6.svg";